<template>
  <section
    class="footer"
  >
    <footer
      id="footerMain"
      v-observe-visibility="{
        callback: editAppIntersectClass,
      }"
    >
      <div class="container">
        <div class="links">
          <ul>
            <li
              v-if="!hideCookieSettings"
            >
              <a
                href="#"
                :title="$t('common:cookie.settings')"
                data-ident="footerShowDisclaimer"
                @click.prevent="showDisclaimer"
              >
                {{ $t('common:cookie.settings') }}
              </a>
            </li>
            <li>
              <a
                :href="arp_linkBuilder({ name: 'Privacy' })"
                :title="$t('common:footer.company.dataProtection')"
                data-ident="footerDataProtection"
                @click.prevent="arp_linkClicker({ name: 'Privacy' })"
              >
                {{ $t('common:footer.company.dataProtection') }}
              </a>
            </li>
            <li>
              <a
                :href="arp_linkBuilder({ name: 'Disclaimer' })"
                :title="$t('common:footer.company.legalNotice')"
                data-ident="footerLegalNotice"
                @click.prevent="arp_linkClicker({ name: 'Disclaimer' })"
              >
                {{ $t('common:footer.company.legalNotice') }}
              </a>
            </li>
            <li>
              <a
                :href="arp_linkBuilder({ name: 'TravelConditions' })"
                :title="$t('common:footer.vacationer.travelConditions')"
                data-ident="footerTravelConditions"
                @click.prevent="arp_linkClicker({ name: 'TravelConditions' })"
              >
                {{ $t('common:footer.vacationer.travelConditions') }}
              </a>
            </li>
          </ul>
          <div class="bottom">
            <div class="p-3">
              <small>{{ $t('common:footer.cooperation') }}</small>
            </div>
            <div class="logo text-center">
              <ed-logo />
            </div>
            <div class="p-3">
              <small>{{ $t('common:footer.copyright') }}</small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </section>
</template>
<script>

import AnchorRouterPush from 'mixins/AnchorRouterPush';
import IntersectionObserverHelper from 'mixins/IntersectionObserverHelper';
import EdLogo from 'icons/logo-e-domizil-mit-hintergrund.svg';

import { mapMutations } from 'vuex';

export default {
  name: 'FooterLayout',
  components: { EdLogo },
  mixins: [
    IntersectionObserverHelper,
    AnchorRouterPush,
  ],
  computed: {
    hideCookieSettings() {
      return this.$route.meta.hideCookieSettings || 0;
    },
  },
  methods: {
    ...mapMutations({ setShowDisclaimer: 'SHOW_COOKIE_DISCLAIMER' }),
    showDisclaimer() {
      this.setShowDisclaimer(true);
    },
  },
};
</script>
<style lang="scss" scoped>

  section.footer {
    margin: 0;
  }

  footer {
    background: var(--color_grey_bg);
    padding: 2em 0;
    margin: 3em 0 0;
    line-height: 1.3em;
    .logo{
      svg{
        width:200px;
        max-width:100%;
      }
    }
  }

  .links {
    margin: 0 0 $margin_content;
    padding: 0;
    text-align: center;

    ul {
      text-align: center;
      margin: 0;
      padding: 0;

      li {
        list-style: none;
        padding: 0;
        display: inline-block;
        margin: 0 0.5em 0.5em;
      }
    }
  }
</style>
